<template>
  <div
    v-show="rlId !== null"
    v-loading="loading"
    element-loading-text="提交中"
    element-loading-spinner="el-icon-loading"
  >
    <el-form ref="uploadForm" :model="uploadForm" label-width="0px">
      <el-row>
        <el-col :span="24">
          <el-upload
            :action="action"
            :data="parm"
            class="upload-demo"
            ref="upload"
            :headers="headers"
            :on-change="handleChange"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :show-file-list="false"
            multiple
          >
            <el-button type="primary" icon="el-icon-upload" plain
              >选择附件</el-button
            >
            <div class="upload-tips">(单个文件不能超过50M，支持所有扩展名)</div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
    <div v-show="cgw.cgwList.length > 0">
      <el-table
        :data="cgw.cgwList"
        fit
        size="mini"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          prop="filename"
          label="文件名字"
          min-width="250px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.filename + scope.row.extname }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="备注"
          align="left"
          prop="bz"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" align="left" prop="name">
          <template slot-scope="scope">
            <el-button type="text" @click="toBz(scope.row)">备注</el-button>
            <el-button @click="downloadFile(scope.row)" type="text"
              >下载</el-button
            >
            <el-popconfirm
              title="确定删除吗？"
              @confirm="deleteFile(scope.row)"
            >
              <el-button slot="reference" type="text" style="color: red"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <el-input
      style="margin-top: 15px"
      type="textarea"
      placeholder="请输入任务备注"
      v-model="uploadForm.bz"
      maxlength="100"
      show-word-limit
    ></el-input>
    <div v-show="cgw.cgwYtjList.length > 0">
      <div class="tips">成果物</div>
      <el-table
        :data="cgw.cgwYtjList"
        size="mini"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">{{
            scope.row.ygbh === scope.row.uploader
              ? scope.row.xm + "(认领人)"
              : scope.row.xm + "(协作人)"
          }}</template>
        </el-table-column>
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          prop="filename"
          label="文件名字"
          min-width="250px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.filename + scope.row.extname }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="备注"
          align="left"
          prop="bz"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" align="left" prop="name">
          <template slot-scope="scope">
            <el-button @click="downloadFile(scope.row)" type="text"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <div v-show="cgw.reviewList.length > 0">
      <div class="tips">审核人意见</div>
      <el-tabs>
        <el-tab-pane
          v-for="(item, index) in cgw.reviewList"
          :label="'第' + (cgw.reviewList.length - index) + '轮评审'"
          :key="index"
        >
          <el-tabs type="card">
            <el-tab-pane v-for="(it, i) in item.reviewList" :key="i">
              <span slot="label">
                {{ it.xm + "/" }}
                <el-tag type="success" size="small" v-show="it.status === 1"
                  >通过</el-tag
                >
                <el-tag type="danger" size="small" v-show="it.status === 0"
                  >不通过</el-tag
                >
                <el-tag size="small" v-show="it.status === 2">未审核</el-tag>
              </span>
              <el-card class="box-card" v-show="it.sj" shadow="hover">
                <div slot="header" class="clearfix">
                  <span>{{ it.sj }}</span>
                </div>
                <div class="text item">{{ it.bz }}</div>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-show="cgw.cgwPzYtjList.length > 0">
      <div class="tips">成果物批注附件</div>
      <el-table
        :data="cgw.cgwPzYtjList"
        size="mini"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          prop="filename"
          label="文件名字"
          min-width="250px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.filename + scope.row.extname }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <!-- <el-table-column
          label="备注"
          align="left"
          prop="bz"
          min-width="200px"
          :show-overflow-tooltip="true"
        />-->
        <el-table-column label="操作" align="left" prop="name">
          <template slot-scope="scope">
            <el-button @click="downloadFile(scope.row)" type="text"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <el-form>
      <el-row class="uploadButton">
        <el-button @click="hideDialog()">取消</el-button>
        <el-button type="primary" @click="submitForm()">提交</el-button>
      </el-row>
    </el-form>
    <el-dialog
      title="编辑备注"
      :visible.sync="bzDialog"
      width="500px"
      top="100px"
      :modal="false"
    >
      <el-input
        v-model="file.bz"
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBz">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "uploadForm",
  computed: { ...mapGetters(["cgw"]) },
  props: {
    mxParams: {
      type: Object,
    },
  },
  data() {
    return {
      rlId: null,
      loading: false,
      fileList: [],
      uploadForm: { bz: null },
      action: window.g.apiUrl + "pmp/cgw/cgwUpload",
      parm: {},
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      bzDialog: false,
      file: {},
    };
  },
  created() {
    this.$store
      .dispatch("cgw/fetchRlIdByTaskIdAction", { taskId: this.mxParams.id })
      .then((success) => {
        if (success.code === 0) {
          if (success.data) {
            this.rlId = success.data;
            this.$store.dispatch("cgw/fetchCgwListAction", {
              type: 2,
              isTj: 0,
            });

            this.$store.dispatch("cgw/fetchCgwYtjListAction", {
              rlId: success.data,
            });

            this.$store.dispatch("cgw/fetchCgwPzYtjListAction", {
              rlId: success.data,
            });

            this.$store.dispatch("cgw/fetchCgwReviewAction", {
              rlId: success.data,
            });
          } else {
            this.rlId = null;
            this.$message.error(
              "您未认领该任务,或已提交了成果物，暂时无法继续提交!"
            );
            this.$emit("hideDialog");
          }
        }
      });
  },
  mounted() {
    this.parm = {
      type: 2,
      taskId: this.mxParams.id,
      rwbh: this.mxParams.rwbh,
    };

    // if (this.rlId !== null) {

    // }
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    hideDialog() {
      this.$emit("hideDialog", this.cgw.cgwList);
    },
    toBz(file) {
      this.file = file;
      this.bzDialog = true;
    },
    saveBz() {
      this.$store
        .dispatch("cgw/fetchUpdateBzAction", {
          fileId: this.file.fileid,
          bz: this.file.bz,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$store.dispatch("cgw/fetchCgwListAction", {
              type: 2,
              isTj: 0,
            });
          }
        });
      this.bzDialog = false;
    },
    openPreview(row) {
      const url = row.previewurl;
      window.open(url);
    },
    downloadFile(row) {
      const filePath = row.url;
      const fileName = row.filename + row.extname;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    deleteFile(file) {
      this.$store
        .dispatch("cgw/fetchDeleteFileAction", {
          fileId: file.fileid,
          path: file.url,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$store.dispatch("cgw/fetchCgwListAction", {
              type: 2,
              isTj: 0,
            });
          }
        });
    },
    beforeUpload(file) {
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
    },
    handleChange(file, fileList) {
      this.$store.dispatch("cgw/fetchCgwListAction", { type: 2, isTj: 0 });
    },
    submitForm() {
      this.loading = true;
      const fileids = [];
      this.cgw.cgwList.forEach((item) => {
        fileids.push(item.fileid);
      });
      if (fileids.length === 0 && !this.uploadForm.bz) {
        this.$message.error("请输入选择成果物文件或输入任务备注！");
        this.loading = false;
        return;
      }
      this.$store
        .dispatch("cgw/saveCgwAndAuditAction", {
          fileIds: fileids.toString(),
          taskId: this.mxParams.id,
          bz: this.uploadForm.bz,
          txlx: this.mxParams.txlx,
          rwmc: this.mxParams.title,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$message.success("保存成功!");
            this.$emit("hideDialog");
          } else {
            this.$message.error(success.msg);
            this.loading = false;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.uploadButton {
  text-align: right;
  margin-top: 15px;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.upload-tips {
  position: absolute;
  top: 10px;
  left: 140px;
}
</style>